import React, { useState } from 'react';
import cn from 'classnames';
import Tooltip from '../Tooltip';

const IndividualTileBadge = ({ label, icon, tooltip = '', className = '' }) => {
    const [isTooltipShown, setIsTooltipShown] = useState(false)
    const hasTooltip = Boolean(tooltip)

    return (
        <div className={`flex items-start mb-1 ${hasTooltip && isTooltipShown ? 'flex-col' : 'flex-row'} ${hasTooltip ? 'cursor-pointer' : ''}`} onClick={hasTooltip ? () => setIsTooltipShown(!isTooltipShown) : null}>
            <p
                className={cn({
                    'text-sm inline-flex justify-center items-center text-primary-blue m-0': true,
                    '[&>svg]:pr-2 [&>svg]:w-6 [&>svg]:h-6 [&>svg]:inline-block [&>svg]:flex-shrink-0 [&>svg]:select-none': true,
                    [className]: Boolean(className),
                })}
            >
                { icon }
                { label }

                {hasTooltip &&
                    <span className='pl-1'>
                        <Tooltip size='20px' onClick={() => {}} />
                    </span>
                }
            </p>
            
            {hasTooltip && isTooltipShown && <p className='text-sm m-0 my-2'>{ tooltip }</p>}
        </div>
    );
};

export default IndividualTileBadge;
